import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { InvestmentAssetClassAllocationModel } from '../../Models/Models/PortfolioAnalysis/Investment/InvestmentAssetClassAllocationModel';
import { AssetClassType } from '../../Constants/Enums/Domain/Instrument/AssetClassType';
import { IJsonDate } from '../../System/IJsonDate';

declare var IS_RUNNING_IN_APP_POOL;

export class InvestmentAssetClassAllocationClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyIds: Array<string>, assetClassType: AssetClassType, asAt: IJsonDate): Promise<InvestmentAssetClassAllocationModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/PortfolioValuation/InvestmentAssetClassAllocation/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyIds: hierarchyIds, assetClassType: assetClassType, asAt: asAt }

    return AjaxWrapper.get<InvestmentAssetClassAllocationModel, any>(url, data);
  }
}

